export const IconeWhatsApp = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.21 4.03009C10.26 4.44009 5.51 9.38009 5.32 15.3401C5.24 17.7501 5.89 20.0801 7.19 22.0801L4.25 28.0001C4.34 28.0001 11.52 26.0601 11.52 26.0601C13.21 26.9701 15.11 27.4401 17.04 27.4401C23.5 27.4401 28.76 22.1801 28.76 15.7201C28.76 9.26009 23.05 3.56009 16.21 4.03009ZM17.03 25.4001C15.32 25.4001 13.63 24.9401 12.16 24.0801C12 23.9901 11.79 23.8401 11.79 23.8401C11.79 23.8401 11.46 23.9501 11.37 23.9701L8.16 24.8501L9.53 21.8301C7.98 19.9201 7.22 17.5601 7.37 15.1001C7.66 10.3001 11.54 6.39009 16.34 6.06009C21.98 5.67009 26.7 10.1501 26.7 15.7101C26.7 21.2701 22.36 25.3901 17.02 25.3901L17.03 25.4001Z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5401 17.4801C21.0501 17.1901 20.4101 16.8601 19.8301 17.1001C19.3901 17.2801 19.1001 17.9801 18.8201 18.3301C18.6701 18.5101 18.5001 18.5401 18.2701 18.4501C16.6001 17.7901 15.3301 16.6701 14.4101 15.1401C14.2501 14.9001 14.2801 14.7101 14.4701 14.4901C14.7501 14.1601 15.1001 13.7901 15.1701 13.3501C15.2501 12.9101 15.0401 12.3901 14.8601 12.0001C14.6301 11.5001 14.3701 10.7801 13.8701 10.5001C13.4101 10.2401 12.8001 10.3901 12.3901 10.7201C11.6801 11.3001 11.3401 12.2001 11.3501 13.1001C11.3501 13.3601 11.3801 13.6101 11.4401 13.8601C11.9401 15.9101 13.3501 17.6401 15.0001 18.8901C16.4201 19.9701 18.7701 21.4301 20.6401 21.0801C21.5501 20.9101 22.4401 20.3501 22.8001 19.4701C22.9101 19.2101 22.9601 18.9201 22.9001 18.6501C22.7801 18.0901 22.0101 17.7501 21.5501 17.4801H21.5401Z"
        fill="#F5F5F5"
      />
    </svg>
  );
};
